export default function initHeader() {
  setHeaderHeight();
  initMegaMenu();
  scrollHeaderFixed();
  langSelectBox();
}

/**
 * ヘッダーの高さをCSS変数に設定する関数
 * 要素のリサイズを検知して再取得します。
 */
function setHeaderHeight(cssVariableName = "--header-height-gutter") {
  const header = document.querySelector(".js-header-fixed");
  if (!header) return;

  let headerH = header.clientHeight;
  document.documentElement.style.setProperty(cssVariableName, headerH + "px");

  // 要素のリサイズを監視して再取得
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      // ヘッダーの高さを再設定
      headerH = entry.target.clientHeight;
      document.documentElement.style.setProperty(cssVariableName, headerH + "px");
    }
  });
  resizeObserver.observe(header);
}

/**
 * scrollでheader固定
 */
function scrollHeaderFixed() {
  const fixedHeader = document.querySelector(".js-header-fixed");

  if (!fixedHeader) return;

  function scrollHandler() {
    // 一定量スクロールしたら表示
    fixedHeader.classList.toggle("is-header-fixed", window.scrollY > 100);
  }

  window.addEventListener("scroll", scrollHandler);
  scrollHandler();
}

function initMegaMenu() {
  const allDetails = document.querySelectorAll(".js-mega-menu-details");

  allDetails.forEach((details) => {
    const summary = details.querySelector(".js-mega-menu-trigger");
    const content = details.querySelector(".js-mega-menu");
    const closeBtn = details.querySelector(".js-mega-menu-close");

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      if (details.hasAttribute("open")) {
        closeMenu(details, content);
      } else {
        closeAllMenus();
        openMenu(details, content);
      }
    });

    // 閉じるボタン
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        closeMenu(details, content);
      });
    }
  });

  // 外側クリックで閉じる
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".js-mega-menu-details")) {
      closeAllMenus();
    }
  });

  //メニューを開く
  function openMenu(details, content) {
    details.setAttribute("open", "true");

    requestAnimationFrame(() => {
      content.classList.add("is-open");
    });
  }

  // メニューを閉じる
  function closeMenu(details, content) {
    content.classList.remove("is-open");

    setTimeout(() => {
      details.removeAttribute("open");
    }, 200);
  }

  // 他のすべてのメニューを閉じる
  function closeAllMenus() {
    allDetails.forEach((details) => {
      if (details.hasAttribute("open")) {
        const content = details.querySelector(".js-mega-menu");
        closeMenu(details, content);
      }
    });
  }
}

/**
 * 言語切り替えボタン アイコン部分でもセレクトボックスを表示できるように
 */
function langSelectBox() {
  const btn = document.querySelector(".js-lang-select-btn");
  const select = document.getElementById("js-lang-select");

  if (btn && select) {
    btn.addEventListener("click", () => {
      if ("showPicker" in HTMLSelectElement.prototype) {
        select.showPicker();
      } else {
        // 非対応ブラウザ用（フォーカスだけあてる）
        select.focus();
      }
    });
  }
}
